import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function SupportAndManagedServices() {
  return (
    <>
      <Breadcrumb title="Support & Managed Services" />

      <div className="page-service-single">
        <div className="container">
          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">
                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="/assets/images/managed-services.png"
                      alt="Support and Managed Services"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We provide end-to-end support and managed services to ensure
                    your digital platforms run smoothly, securely, and without
                    interruption. Our teams act as an extension of your
                    organization to proactively monitor, maintain, and optimize
                    systems.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>24/7 system monitoring & proactive support</li>
                    <li>Application, infrastructure & cloud management</li>
                    <li>
                      Issue resolution, updates & performance optimization
                    </li>
                    <li>Security monitoring & compliance support</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Reduced downtime & operational risk</li>
                    <li>Predictable system performance</li>
                    <li>Lower IT overhead & faster issue resolution</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Service Blocks */}
          <div className="row">
            <ServiceBlock
              title="Application Support"
              items={[
                "Website & web application support",
                "Bug fixing & issue resolution",
                "Version upgrades & patch management",
                "Performance tuning & optimization",
              ]}
            />

            <ServiceBlock
              title="Infrastructure & Cloud Management"
              items={[
                "AWS, Azure & GCP management",
                "Server & hosting monitoring",
                "Backup & disaster recovery",
                "Scalability & cost optimization",
              ]}
            />

            <ServiceBlock
              title="Monitoring & Operations"
              items={[
                "24/7 uptime monitoring",
                "Incident detection & alerts",
                "SLA-based response handling",
                "Root cause analysis (RCA)",
              ]}
            />

            <ServiceBlock
              title="Helpdesk & User Support"
              items={[
                "Tier 1, Tier 2 & Tier 3 support",
                "Ticketing system management",
                "Remote troubleshooting",
                "User access & role management",
              ]}
            />

            <ServiceBlock
              title="Security & Compliance Support"
              items={[
                "Security monitoring & audits",
                "Access control & authentication",
                "Compliance support (HIPAA, GDPR)",
                "Vulnerability & patch management",
              ]}
            />

            <ServiceBlock
              title="Continuous Improvement"
              items={[
                "Performance reporting & insights",
                "System optimization recommendations",
                "Process automation support",
                "Technology roadmap planning",
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

/* ✅ Reusable Service Block */
function ServiceBlock({ title, items }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <h3>{title}</h3>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
